import { createSelector } from '@reduxjs/toolkit';
import orderBy from 'lodash/orderBy';

const baseSelector = (state) => state.rescheduleClassesForm;

export const rescheduleClassesFormSelector = (state) => baseSelector(state);

export const rescheduleClassesStageSelector = (state) =>
  baseSelector(state).rescheduleClassesStage;

export const rescheduleClassesFormAcademyScheduleSelector = (state) =>
  baseSelector(state).academySchedule;

export const rescheduleClassesFormStartDateSelector = (state) =>
  baseSelector(state).startDate;

export const rescheduleErrorsSelector = (state) => baseSelector(state).errors;

export const sbatGroupsSelector = (state) => baseSelector(state).sbatGroups;

export const rescheduleClassesFormCommunicationsSelector = (state) =>
  baseSelector(state).communications;

export const bulkRescheduleReasonSelector = (state) =>
  baseSelector(state).rescheduleReason;

export const bulkRescheduleValidateErrorMessageSelector = (state) =>
  baseSelector(state).bulkRescheduleValidateErrorMessage;

export const sbatGroupListSelector = createSelector(
  sbatGroupsSelector,
  (sbatGroups) => {
    return orderBy(Object.values(sbatGroups), 'order', 'asc');
  }
);

export const selectedSbatGroupsSelector = createSelector(
  sbatGroupListSelector,
  (sbatGroups) => {
    return sbatGroups.filter((o) => !o.locked);
  }
);

export const lockedSbatGroupsSelector = createSelector(
  sbatGroupListSelector,
  (sbatGroups) => {
    return sbatGroups.filter((o) => o.locked);
  }
);
